import { alpha, createTheme } from "@mui/material/styles";

// Each entry's `id` is the value stored as `organization.omniData.themeId` on org records.
// It must stay stable and unique even if entries are reordered — always add new themes with a
// new max+1 id appended at the end, never reuse or renumber an existing id.
export const themeDefinitions = [
  {
    id: 0,
    themeName: "Omniscia Default Theme",
    //delete or clean up all below
    palette: {
      light: {
        mode: "light",
        primary: {
          main: "#033241",
        },
        secondary: {
          main: "#1E758D",
        },
        background: {
          //the backdrop
          main: "#6D6D6D",
          contrastText: "#DDD",
        },
        commonground: {
          //widgets and dialogs
          main: "#F2F2F2",
          contrastText: "#2c343a",
        },
        foreground: {
          //Widget and dialog Contents
          main: "#FFF",
          contrastText: "#222",
        },
        highlight: {
          main: "#F5C336",
          contrastText: "#222",
        },
      },
      dark: {
        // background/commonground/foreground come from the shared DARK_NEUTRALS below —
        // MUI derives palette.mode from the colorSchemes key ("dark"/"light") itself, so it
        // doesn't need to be set explicitly here.
        primary: {
          main: "#033241",
        },
        secondary: {
          main: "#1E758D",
        },
        highlight: {
          main: "#F5C336",
          contrastText: "#222",
        },
      },
    },
    sizing: {
      tiny: 90,
      small: 128,
      half: 256,
      medium: 475,
      large: 600,
      full: `calc(100vh - 156px)`,
      width: "sm",
    },

    graphColors: [
      "#ff595e",
      "#ff924c",
      "#ffca3a",
      "#c5ca30",
      "#8ac926",
      "#36949d",
      "#1982c4",
      "#4267ac",
      "#565aa0",
      "#6a4c93",
    ],

  },
  {
    id: 1,
    themeName: "Park View Credit Union",
    //delete or clean up all below
    palette: {
      light: {
        primary: {
          main: "#11809D",
        },
        secondary: {
          main: "#B6D3D5",
        },
        background: {
          main: "#555",
          contrastText: "#EEE",
        },
        commonground: {
          main: "#F2F2F2",
          contrastText: "#2c343a",
        },
        foreground: {
          main: "#FFF",
          contrastText: "#222",
        },
        highlight: {
          main: "#9D509F",
          contrastText: "#DDD",
        },
      },
      dark: {
        primary: {
          main: "#11809D",
        },
        secondary: {
          main: "#B6D3D5",
        },
        highlight: {
          main: "#9D509F",
          contrastText: "#DDD",
        },
      },
    },
    sizing: {
      tiny: 90,
      small: 128,
      half: 256,
      medium: 475,
      large: 600,
      full: `calc(100vh - 156px)`,
      width: "sm",
    },

    graphColors: [
      "#ff595e",
      "#ff924c",
      "#ffca3a",
      "#c5ca30",
      "#8ac926",
      "#36949d",
      "#1982c4",
      "#4267ac",
      "#565aa0",
      "#6a4c93",
    ],
  },
  {
    id: 2,
    themeName: "Omniscia Health Theme",
    //delete or clean up all below
    palette: {
      light: {
        background: {
          main: "#DAE8F5",
          contrastText: "#222",
        },
        primary: {
          main: "#0D3B66",
        },
        secondary: {
          main: "#1A73C7",
        },
        commonground: {
          main: "#F2F2F2",
          contrastText: "#2c343a",
        },
        foreground: {
          main: "#FFF",
          contrastText: "#222",
        },
        info: {
          main: "#0D3B66",
          contrastText: "#F3F2F3",
        },
        highlight: {
          main: "#FFD94E",
          contrastText: "#111",
        },
      },
      dark: {
        primary: {
          main: "#0D3B66",
        },
        secondary: {
          main: "#1A73C7",
        },
        info: {
          main: "#0D3B66",
          contrastText: "#F3F2F3",
        },
        highlight: {
          main: "#FFD94E",
          contrastText: "#111",
        },
      },
    },
    sizing: {
      tiny: 90,
      small: 128,
      half: 256,
      medium: 475,
      large: 600,
      full: `calc(100vh - 156px)`,
      width: "sm",
    },

    graphColors: [
      "#ff595e",
      "#ff924c",
      "#ffca3a",
      "#c5ca30",
      "#8ac926",
      "#36949d",
      "#1982c4",
      "#4267ac",
      "#565aa0",
      "#6a4c93",
    ],
  },
  {
    id: 3,
    themeName: "MECE Credit Union",
    //delete or clean up all below
    palette: {
      light: {
        background: {
          main: "#D2D4D9",
          contrastText: "#2c343a",
        },
        primary: {
          main: "#37748C",
        },
        secondary: {
          main: "#4B9EBF",
        },
        commonground: {
          main: "#F2F2F2",
          contrastText: "#2c343a",
        },
        foreground: {
          main: "#FFF",
          contrastText: "#2c343a",
        },
        info: {
          main: "#37748C",
          contrastText: "#FFF",
        },
        highlight: {
          main: "#7EB9BF",
          contrastText: "#fff",
        },
      },
      dark: {
        primary: {
          main: "#37748C",
        },
        secondary: {
          main: "#4B9EBF",
        },
        info: {
          main: "#37748C",
          contrastText: "#FFF",
        },
        highlight: {
          main: "#7EB9BF",
          contrastText: "#fff",
        },
      },
    },
    sizing: {
      tiny: 90,
      small: 128,
      half: 256,
      medium: 475,
      large: 600,
      full: `calc(100vh - 156px)`,
      width: "sm",
    },

    graphColors: [
      "#ff595e",
      "#ff924c",
      "#ffca3a",
      "#c5ca30",
      "#8ac926",
      "#36949d",
      "#1982c4",
      "#4267ac",
      "#565aa0",
      "#6a4c93",
    ],
  },
  {
    id: 4,
    themeName: "Neuro Rails Visions",
    //delete or clean up all below
    palette: {
      light: {
        background: {
          main: "#f9f9fb",
          contrastText: "#25272a",
        },
        primary: {
          main: "#c1590c",
        },
        secondary: {
          main: "#254f9d",
        },
        commonground: {
          main: "#f9f9fb",
          contrastText: "#25272a",
        },
        foreground: {
          main: "#FFF",
          contrastText: "#25272a",
        },
        info: {
          main: "#EF5F24",
          contrastText: "#FFF",
        },
        highlight: {
          main: "#f79f7e ",
          contrastText: "#fff",
        },
      },
      dark: {
        primary: {
          main: "#c1590c",
        },
        secondary: {
          main: "#254f9d",
        },
        info: {
          main: "#EF5F24",
          contrastText: "#FFF",
        },
        highlight: {
          main: "#f79f7e ",
          contrastText: "#fff",
        },
      },
    },
    sizing: {
      tiny: 90,
      small: 128,
      half: 256,
      medium: 475,
      large: 600,
      full: `calc(100vh - 156px)`,
      width: "sm",
    },

    graphColors: [
      "#ff595e",
      "#ff924c",
      "#ffca3a",
      "#c5ca30",
      "#8ac926",
      "#36949d",
      "#1982c4",
      "#4267ac",
      "#565aa0",
      "#6a4c93",
    ],
  },
  {
    id: 5,
    themeName: "Empire Operating System",
    //delete or clean up all below
    palette: {
      light: {
        background: {
          main: "#ddd",
          contrastText: "#25272a",
        },
        primary: {
          main: "#D8BC61",
          contrastText: "#222",
        },
        secondary: {
          main: "#82713A",
          contrastText: "#F2F2F2",
        },
        commonground: {
          main: "#F2F2F2",
          contrastText: "#25272a",
        },
        foreground: {
          main: "#FFF",
          contrastText: "#25272a",
        },
        error: {
          main: "#F0636C",
        },
        warning: {
          main: "#FCB814",
          contrastText: "#25272a",
        },
        info: {
          main: "#6767AF",
          contrastText: "#F3F2F3",
        },
        success: {
          main: "#68C4A2",
          contrastText: "#25272a",
        },
        highlight: {
          main: "#17AFD0 ",
          contrastText: "#25272a",
        },
      },
      dark: {
        primary: {
          main: "#D8BC61",
          contrastText: "#222",
        },
        secondary: {
          main: "#82713A",
          contrastText: "#F2F2F2",
        },
        error: {
          main: "#F0636C",
        },
        warning: {
          main: "#FCB814",
          contrastText: "#25272a",
        },
        info: {
          main: "#6767AF",
          contrastText: "#F3F2F3",
        },
        success: {
          main: "#68C4A2",
          contrastText: "#25272a",
        },
        highlight: {
          main: "#17AFD0 ",
          contrastText: "#25272a",
        },
      },
    },
    sizing: {
      tiny: 90,
      small: 128,
      half: 256,
      medium: 475,
      large: 600,
      full: `calc(100vh - 156px)`,
      width: "sm",
    },

    graphColors: [
      "#ff595e",
      "#ff924c",
      "#ffca3a",
      "#c5ca30",
      "#8ac926",
      "#36949d",
      "#1982c4",
      "#4267ac",
      "#565aa0",
      "#6a4c93",
    ],
  },
  {
    id: 6,
    themeName: "Nsight",
    //delete or clean up all below
    palette: {
      light: {
        background: {
          main: "#dee3e6",
          contrastText: "#FFF",
        },
        primary: {
          main: "#4CC6EA",
          contrastText: "#FFF",
        },
        secondary: {
          main: "#D05EBE",
          contrastText: "#F2F2F2",
        },
        commonground: {
          main: "#F2F2F2",
          contrastText: "#25272a",
        },
        foreground: {
          main: "#FFF",
          contrastText: "#25272a",
        },
        error: {
          main: "#F0636C",
        },
        warning: {
          main: "#FCB814",
          contrastText: "#25272a",
        },
        info: {
          main: "#6767AF",
          contrastText: "#F3F2F3",
        },
        success: {
          main: "#68C4A2",
          contrastText: "#25272a",
        },
        highlight: {
          main: "#17AFD0 ",
          contrastText: "#25272a",
        },
      },
      dark: {
        primary: {
          main: "#4CC6EA",
          contrastText: "#FFF",
        },
        secondary: {
          main: "#D05EBE",
          contrastText: "#F2F2F2",
        },
        error: {
          main: "#F0636C",
        },
        warning: {
          main: "#FCB814",
          contrastText: "#25272a",
        },
        info: {
          main: "#6767AF",
          contrastText: "#F3F2F3",
        },
        success: {
          main: "#68C4A2",
          contrastText: "#25272a",
        },
        highlight: {
          main: "#17AFD0 ",
          contrastText: "#25272a",
        },
      },
    },
    sizing: {
      tiny: 90,
      small: 128,
      half: 256,
      medium: 475,
      large: 600,
      full: `calc(100vh - 156px)`,
      width: "sm",
    },

    graphColors: [
      "#ff595e",
      "#ff924c",
      "#ffca3a",
      "#c5ca30",
      "#8ac926",
      "#36949d",
      "#1982c4",
      "#4267ac",
      "#565aa0",
      "#6a4c93",
    ],
  },
  {
    id: 7,
    themeName: "Hyperbaric Wellness",
    //delete or clean up all below
    palette: {
      light: {
        background: {
          main: "#dee3e6",
          contrastText: "#FFF",
        },
        primary: {
          main: "#0eb1bb",
          contrastText: "#FFF",
        },
        secondary: {
          main: "#094c6e",
          contrastText: "#F2F2F2",
        },
        commonground: {
          main: "#F2F2F2",
          contrastText: "#25272a",
        },
        foreground: {
          main: "#FFF",
          contrastText: "#25272a",
        },
        error: {
          main: "#F0636C",
        },
        warning: {
          main: "#FCB814",
          contrastText: "#25272a",
        },
        info: {
          main: "#6767AF",
          contrastText: "#F3F2F3",
        },
        success: {
          main: "#68C4A2",
          contrastText: "#25272a",
        },
        highlight: {
          main: "#17AFD0 ",
          contrastText: "#25272a",
        },
      },
      dark: {
        primary: {
          main: "#0eb1bb",
          contrastText: "#FFF",
        },
        secondary: {
          main: "#094c6e",
          contrastText: "#F2F2F2",
        },
        error: {
          main: "#F0636C",
        },
        warning: {
          main: "#FCB814",
          contrastText: "#25272a",
        },
        info: {
          main: "#6767AF",
          contrastText: "#F3F2F3",
        },
        success: {
          main: "#68C4A2",
          contrastText: "#25272a",
        },
        highlight: {
          main: "#17AFD0 ",
          contrastText: "#25272a",
        },
      },
    },
    sizing: {
      tiny: 90,
      small: 128,
      half: 256,
      medium: 475,
      large: 600,
      full: `calc(100vh - 156px)`,
      width: "sm",
    },

    graphColors: [
      "#ff595e",
      "#ff924c",
      "#ffca3a",
      "#c5ca30",
      "#8ac926",
      "#36949d",
      "#1982c4",
      "#4267ac",
      "#565aa0",
      "#6a4c93",
    ],
  },
  {
    id: 8,
    themeName: "Directions Credit Union",

    palette: {
      light: {
        // Primary: Desaturated, sophisticated slate-maroon (toned down from the header)
        primary: {
          main: "#8E2B38", // Softened crimson/burgundy
          light: "#A44551",
          dark: "#691E27",
          contrastText: "#FFFFFF",
        },
        // Secondary: Calmed, desaturated slate-navy (toned down from the hero banner)
        secondary: {
          main: "#2E4A70", // Muted navy with gray undertones
          light: "#49668E",
          dark: "#1A304D",
          contrastText: "#FFFFFF",
        },
        // App background canvas
        background: {
          main: "#F5F7FA", // Clean, soft ice-white canvas
          contrastText: "#232B38",
        },
        // Modernized typography to soften UI text
        text: {
          primary: "#232B38", // Deep charcoal slate instead of stark pitch black
          secondary: "#626E82", // Slate gray for secondary details/labels
        },
        divider: "#E4E9F0", // Gentle borders to split grid zones cleanly

        // Custom wrapper mappings for backward compatibility
        commonground: {
          main: "#EDF2F7",
          contrastText: "#232B38",
        },
        foreground: {
          main: "#FFFFFF",
          contrastText: "#232B38",
        },
        info: {
          main: "#4A7C9D", // Desaturated blue tint for standard alerts
          contrastText: "#FFFFFF",
        },
        highlight: {
          main: "#8E2B38",
          contrastText: "#FFFFFF",
        },
      },
      dark: {
        primary: {
          main: "#8E2B38",
          light: "#A44551",
          dark: "#691E27",
          contrastText: "#FFFFFF",
        },
        secondary: {
          main: "#2E4A70",
          light: "#49668E",
          dark: "#1A304D",
          contrastText: "#FFFFFF",
        },
        // background/commonground/foreground come from the shared DARK_NEUTRALS; text/divider
        // are deliberately NOT overridden here (unlike the light palette above) so MUI's own
        // dark-mode-appropriate defaults apply instead of this org's light-tuned slate/gray.
        info: {
          main: "#4A7C9D",
          contrastText: "#FFFFFF",
        },
        highlight: {
          main: "#8E2B38",
          contrastText: "#FFFFFF",
        },
      },
    },
    sizing: {
      tiny: 90,
      small: 128,
      half: 256,
      medium: 475,
      large: 600,
      full: `calc(100vh - 156px)`,
      width: "sm",
    },

    graphColors: [
      "#ff595e",
      "#ff924c",
      "#ffca3a",
      "#c5ca30",
      "#8ac926",
      "#36949d",
      "#1982c4",
      "#4267ac",
      "#565aa0",
      "#6a4c93",
    ],

  },
];

if (process.env.NODE_ENV !== "production") {
  const seenIds = new Set();
  themeDefinitions.forEach(entry => {
    if (seenIds.has(entry.id)) {
      throw new Error(
        `mui5themes.js: duplicate theme id ${entry.id} ("${entry.themeName}") — ids must be unique and stable, never reused or reassigned.`,
      );
    }
    seenIds.add(entry.id);
  });
}

const findThemeEntry = themeId => {
  const numericId = typeof themeId === "string" ? parseInt(themeId, 10) : themeId;
  return themeDefinitions.find(entry => entry.id === numericId) ?? themeDefinitions[0];
};

// Shared shape/typography/component tokens applied to every org. The custom Omni* wrapper
// components (Portal, Widget, OmniDialog, OmniTextField, …) already read theme.shape/theme.shadows
// directly rather than relying on MUI's per-component theme.components defaults, so tuning these
// shared tokens once here is what actually cascades a consistent look across the whole app —
// per-org customization lives in each entry's palette instead.
const BASE_SHAPE = {
  borderRadius: 3, // matches the original 8-of-9-org value; 6 (Directions CU's own choice) read as too rounded app-wide.
};

// Matches the system-font stack already declared in src/index.css, so MUI Typography and plain
// HTML text render with the same font instead of silently diverging (MUI defaults to Roboto,
// which isn't loaded here, so it was already falling back to the browser default — this just
// makes that fallback intentional and consistent).
const BASE_TYPOGRAPHY = {
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
};

// Every org previously duplicated this exact MuiButton block, and 6 of the 9 copies hardcoded
// Omniscia Health's #0D3B66 for the hover/active glow instead of the org's own brand color —
// clearly a copy-paste artifact, not an intentional choice. Deriving it from theme.palette.primary
// fixes that for every org at once and removes the duplication entirely.
const BASE_COMPONENTS = {
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
    styleOverrides: {
      root: ({ theme }) => ({
        transform: "scale(1)",
        transformOrigin: "center",
        transition: "all 0.05s ease-out",
        "&:hover, :active": {
          boxShadow: `0px 3px 1px -2px ${alpha(theme.palette.primary.main, 0.08)}, 0px 3px 4px 0px ${alpha(theme.palette.primary.main, 0.08)}, 0px 1px 8px 0px ${alpha(theme.palette.primary.main, 0.08)}`,
          transform: "scale(1.05)",
          transformOrigin: "center",
        },
        "&:active": {
          boxShadow: `inset 0px 3px 1px -2px ${alpha(theme.palette.primary.main, 0.15)}, inset 0px 3px 4px 0px ${alpha(theme.palette.primary.main, 0.15)}, inset 0px 1px 8px 0px ${alpha(theme.palette.primary.main, 0.15)}`,
          transform: "scale(0.975)",
        },
      }),
    },
    variants: [
      {
        props: { variant: "outlined" },
        style: ({ theme }) => ({
          background: theme.palette.commonground.main,
          "&:hover, :active": {
            background: theme.palette.commonground.main,
          },
        }),
      },
    ],
  },
  // Previously only Omniscia Health Theme had this hover/active animation; it was already
  // written generically (theme.palette.secondary.main, no hardcoded colors), so every other
  // org's icon buttons get the same polish for free by lifting it here unchanged.
  MuiIconButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        transform: "scale(1)",
        transformOrigin: "center",
        transition: "all 0.05s ease-out",
        "&:hover": {
          color: theme.palette.secondary.main,
          "& .MuiSvgIcon-root": {
            animationName: `muiSvgIconHover`,
            animationDuration: ".3s",
            animationIterationCount: "1",
            animationTimingFunction: "ease-in-out",
            fill: theme.palette.secondary.main,
          },
        },
        "&:active": {
          animationName: `muiMenuItemActive`,
          animationDuration: ".25s",
          animationIterationCount: "1",
          animationTimingFunction: "ease-in-out",
          "& .MuiSvgIcon-root": {
            animationName: `muiMenuItemActive`,
            animationDuration: ".25s",
            animationIterationCount: "1",
            animationTimingFunction: "ease-in-out",
          },
        },
        "@keyframes muiSvgIconHover": {
          from: { transform: "scale(1) rotate(0deg)" },
          "33%": { transform: "scale(1.10) rotate(2.5deg)" },
          "66%": { transform: "rotate(-2.5deg)" },
          "77%": { transform: "rotate(1.25deg)" },
          "88%": { transform: "rotate(-1.25deg)" },
          to: { transform: "scale(1) rotate(0deg)" },
        },
        "@keyframes muiMenuItemActive": {
          from: { transform: "scale(1)" },
          "50%": { transform: "scale(.95)" },
          to: { transform: "scale(1)" },
        },
      }),
    },
  },
};

// Every org's dark mode shares this one neutral surface set — only brand colors (primary,
// secondary, highlight, graphColors, and error/warning/info/success where an org sets them)
// vary per org and stay mode-invariant (same hex in light and dark). This mirrors each light
// theme's own background < commonground < foreground progression (backdrop darkest/most
// "sunken", widget content lightest/most "raised"), just compressed into Material's subtler
// dark-elevation range instead of light mode's stark mid-gray-to-white swing.
const DARK_NEUTRALS = {
  background: { main: "#121212", contrastText: "#E8E8E8" },
  commonground: { main: "#1E1E1E", contrastText: "#E8E8E8" },
  foreground: { main: "#2A2A2A", contrastText: "#F5F5F5" },
};

// Single source of truth for "what are org X's resolved colors in mode Y" — used by both
// buildOrgTheme (below) and awsTheme.js, so the two never drift out of sync.
export const resolveOrgPalette = (themeId, mode = "light") => {
  const entry = findThemeEntry(themeId);
  const palette = entry.palette[mode] ?? entry.palette.light;
  if (mode !== "dark") {
    return palette;
  }
  return {
    ...palette,
    background: { ...palette.background, ...DARK_NEUTRALS.background },
    commonground: { ...palette.commonground, ...DARK_NEUTRALS.commonground },
    foreground: { ...palette.foreground, ...DARK_NEUTRALS.foreground },
  };
};

// Builds one MUI theme per organization that supports both light and dark mode via MUI's
// CSS-variables colorSchemes, switched at runtime through useColorScheme()/CssBaseline
// rather than needing two separate ThemeProvider trees.
// Fills in the real MUI `background.default`/`.paper` (read by CssBaseline and any built-in
// MUI component we haven't styled explicitly) from this app's own `background`/`foreground`
// concepts, without disturbing the custom keys every existing consumer already reads.
const withStandardBackground = palette => ({
  ...palette,
  background: {
    ...palette.background,
    default: palette.background.main,
    paper: palette.foreground?.main ?? palette.background.main,
  },
});

export const buildOrgTheme = themeId => {
  const entry = findThemeEntry(themeId);
  return createTheme({
    colorSchemes: {
      light: { palette: withStandardBackground(resolveOrgPalette(themeId, "light")) },
      dark: { palette: withStandardBackground(resolveOrgPalette(themeId, "dark")) },
    },
    // MUI defaults colorSchemeSelector to "media" (OS preference only, no manual override —
    // useColorScheme().setMode() is a documented no-op in that mode). We need the user-toggle
    // decision, so switch it to a real DOM attribute.
    colorSchemeSelector: "data-mui-color-scheme",
    shape: BASE_SHAPE,
    typography: BASE_TYPOGRAPHY,
    sizing: entry.sizing,
    graphColors: entry.graphColors,
    components: BASE_COMPONENTS,
  });
};

//ALL BELOW IS AN ACTUAL THEME DEFINITION FOR MATERIAL UI'S V5

// breakpoints: {
//   keys: ["xs", "sm", "md", "lg", "xl"],
//   values: {
//     xs: 0,
//     sm: 600,
//     md: 900,
//     lg: 1200,
//     xl: 1536,
//   },
//   unit: "px",
// },
// direction: "ltr",
// components: {
//   MuiCssBaseline: {
//     defaultProps: {
//       enableColorScheme: true,
//     },
//   },
//   MuiButtonBase: {
//     defaultProps: {
//       disableTouchRipple: true,
//     },
//   },
//   MuiButton: {
//     defaultProps: {
//       disableElevation: true,
//     },
//     styleOverrides: {
//       sizeLarge: {
//         padding: "0.875rem 1rem",
//         fontSize: "1rem",
//         lineHeight: 1.3125,
//         letterSpacing: 0,
//         fontFamily:
//           '"IBM Plex Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//         fontWeight: 700,
//         scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)",
//       },
//       sizeSmall: {
//         padding: "4px 8px",
//         marginLeft: "-8px",
//       },
//       containedPrimary: {
//         backgroundColor: "#007FFF",
//         color: "#fff",
//       },
//     },
//     variants: [
//       {
//         props: {
//           variant: "code",
//         },
//         style: {
//           color: "#2D3843",
//           border: "1px solid",
//           borderColor: "#CDD2D7",
//           backgroundColor: "#F3F6F9",
//           fontFamily: "Consolas,Menlo,Monaco,Andale Mono,Ubuntu Mono,monospace",
//           fontWeight: 400,
//           fontSize: "0.8125rem",
//           lineHeight: 1.5,
//           letterSpacing: 0,
//           WebkitFontSmoothing: "subpixel-antialiased",
//           "&:hover, &.Mui-focusVisible": {
//             borderColor: "#007FFF",
//             backgroundColor: "#F0F7FF",
//             "& .MuiButton-endIcon": {
//               color: "#007FFF",
//             },
//           },
//           "& .MuiButton-startIcon": {
//             color: "#B2BAC2",
//           },
//           "& .MuiButton-endIcon": {
//             display: "inline-block",
//             position: "absolute",
//             right: 0,
//             marginRight: 10,
//             color: "#3E5060",
//           },
//         },
//       },
//       {
//         props: {
//           variant: "link",
//         },
//         style: {
//           fontSize: "0.875rem",
//           fontWeight: 700,
//           color: "#0072E5",
//           mb: 1,
//           "& svg": {
//             ml: -0.5,
//           },
//         },
//       },
//     ],
//   },
//   MuiIconButton: {
//     variants: [
//       {
//         props: {
//           color: "primary",
//         },
//         style: {
//           height: 34,
//           width: 34,
//           border: "1px solid #E0E3E7",
//           borderRadius: 10,
//           color: "#007FFF",
//           "&:hover": {
//             borderColor: "#CDD2D7",
//             background: "#F3F6F9",
//           },
//         },
//       },
//     ],
//   },
//   MuiMenu: {
//     styleOverrides: {
//       paper: {
//         minWidth: 160,
//         color: "#3E5060",
//         backgroundImage: "none",
//         backgroundColor: "#fff",
//         border: "1px solid #E0E3E7",
//         "& .MuiMenuItem-root": {
//           fontSize: "0.875rem",
//           fontWeight: 500,
//           "&:hover": {
//             backgroundColor: "#F3F6F9",
//           },
//           "&:focus": {
//             backgroundColor: "#F3F6F9",
//           },
//           "&.Mui-selected": {
//             fontWeight: 500,
//             color: "#0072E5",
//             backgroundColor: "rgba(194, 224, 255, 0.6)",
//           },
//         },
//       },
//     },
//   },
//   MuiPopover: {
//     styleOverrides: {
//       paper: {
//         boxShadow: "0px 4px 20px rgba(170, 180, 190, 0.3)",
//       },
//     },
//   },
//   MuiContainer: {
//     styleOverrides: {
//       root: {
//         "@media (min-width:900px)": {
//           paddingLeft: "16px",
//           paddingRight: "16px",
//         },
//       },
//     },
//   },
//   MuiDivider: {
//     styleOverrides: {
//       root: {
//         borderColor: "#E7EBF0",
//       },
//     },
//   },
//   MuiLink: {
//     defaultProps: {
//       underline: "none",
//     },
//     styleOverrides: {
//       root: {
//         color: "#0072E5",
//         fontWeight: 700,
//         display: "inline-flex",
//         alignItems: "center",
//         "&:hover": {
//           color: "#0059B2",
//         },
//         "&.MuiTypography-body1 > svg": {
//           marginTop: 2,
//         },
//         "& svg:last-child": {
//           marginLeft: 2,
//         },
//       },
//     },
//   },
//   MuiChip: {
//     styleOverrides: {
//       deleteIcon: {
//         color: "#0059B2",
//         "&:hover": {
//           color: "#003A75",
//         },
//       },
//     },
//   },
//   MuiList: {
//     styleOverrides: {
//       root: {
//         padding: 0,
//       },
//     },
//   },
//   MuiListItemButton: {
//     styleOverrides: {
//       root: {
//         padding: "8px",
//         textTransform: "none",
//         fontWeight: 500,
//         fontSize: "0.875rem",
//         color: "#3E5060",
//         borderRadius: 0,
//         "&:hover": {
//           backgroundColor: "#F3F6F9",
//         },
//         "&.Mui-selected": {
//           color: "#007FFF",
//           borderRadius: 10,
//           border: "1px solid",
//           borderColor: "#007FFF !important",
//           backgroundColor: "#F0F7FF",
//           "&:hover": {
//             backgroundColor: "#C2E0FF",
//           },
//         },
//       },
//     },
//   },
//   MuiSelect: {
//     defaultProps: {
//       IconComponent: {
//         type: {},
//         compare: null,
//       },
//     },
//     styleOverrides: {
//       iconFilled: {
//         top: "calc(50% - .25em)",
//       },
//     },
//   },
//   MuiTab: {
//     defaultProps: {
//       disableTouchRipple: true,
//     },
//   },
//   MuiPaper: {
//     styleOverrides: {
//       root: {
//         backgroundImage: "none",
//         backgroundColor: "#fff",
//         "&[href]": {
//           textDecorationLine: "none",
//         },
//       },
//       outlined: {
//         display: "block",
//         borderColor: "#E0E3E7",
//         "a&, button&": {
//           "&:hover": {
//             boxShadow: "0px 4px 20px rgba(170, 180, 190, 0.3)",
//           },
//         },
//       },
//     },
//   },
//   MuiTableCell: {
//     styleOverrides: {
//       root: {
//         padding: "8px 16px",
//         borderColor: "#E7EBF0",
//       },
//       head: {
//         color: "#1A2027",
//         fontWeight: 700,
//       },
//       body: {
//         color: "#3E5060",
//       },
//     },
//   },
//   MuiToggleButtonGroup: {
//     styleOverrides: {
//       root: {
//         backgroundColor: "#fff",
//       },
//     },
//   },
//   MuiToggleButton: {
//     styleOverrides: {
//       root: {
//         textTransform: "none",
//         fontWeight: 500,
//         color: "#3E5060",
//         borderColor: "#E0E3E7",
//         "&.Mui-selected": {
//           color: "#007FFF",
//           borderColor: "#007FFF !important",
//           backgroundColor: "#F0F7FF",
//           "&:hover": {
//             backgroundColor: "#C2E0FF",
//           },
//         },
//       },
//     },
//   },
//   MuiTooltip: {
//     styleOverrides: {
//       tooltip: {
//         padding: "5px 9px",
//       },
//     },
//   },
//   MuiSwitch: {
//     styleOverrides: {
//       root: {
//         width: 32,
//         height: 20,
//         padding: 0,
//         "& .MuiSwitch-switchBase": {
//           "&.Mui-checked": {
//             transform: "translateX(11px)",
//             color: "#fff",
//           },
//         },
//       },
//       switchBase: {
//         height: 20,
//         width: 20,
//         padding: 0,
//         color: "#fff",
//         "&.Mui-checked + .MuiSwitch-track": {
//           opacity: 1,
//         },
//       },
//       track: {
//         opacity: 1,
//         borderRadius: 32,
//         backgroundColor: "#B2BAC2",
//       },
//       thumb: {
//         flexShrink: 0,
//         width: "14px",
//         height: "14px",
//       },
//     },
//   },
//   MuiPaginationItem: {
//     styleOverrides: {
//       root: {
//         textTransform: "none",
//         fontWeight: 700,
//         color: "#3E5060",
//         borderColor: "#E0E3E7",
//         "&.Mui-selected": {
//           color: "#007FFF",
//           borderColor: "#007FFF !important",
//           backgroundColor: "#F0F7FF",
//           "&:hover": {
//             backgroundColor: "#C2E0FF",
//           },
//         },
//       },
//     },
//   },
// },
// palette: {
//   mode: "light",
//   primary: {
//     50: "#F0F7FF",
//     100: "#C2E0FF",
//     200: "#99CCF3",
//     300: "#66B2FF",
//     400: "#3399FF",
//     500: "#007FFF",
//     600: "#0072E5",
//     700: "#0059B2",
//     800: "#004C99",
//     900: "#003A75",
//     main: "#007FFF",
//     light: "#66B2FF",
//     dark: "#0059B2",
//     contrastText: "#fff",
//   },
//   divider: "#E7EBF0",
//   primaryDark: {
//     50: "#E2EDF8",
//     100: "#CEE0F3",
//     200: "#91B9E3",
//     300: "#5090D3",
//     400: "#265D97",
//     500: "#1E4976",
//     600: "#173A5E",
//     700: "#132F4C",
//     800: "#001E3C",
//     900: "#0A1929",
//     main: "#5090D3",
//   },
//   common: {
//     black: "#1D1D1D",
//     white: "#fff",
//   },
//   text: {
//     primary: "#1A2027",
//     secondary: "#3E5060",
//     disabled: "rgba(0, 0, 0, 0.38)",
//   },
//   grey: {
//     50: "#F3F6F9",
//     100: "#E7EBF0",
//     200: "#E0E3E7",
//     300: "#CDD2D7",
//     400: "#B2BAC2",
//     500: "#A0AAB4",
//     600: "#6F7E8C",
//     700: "#3E5060",
//     800: "#2D3843",
//     900: "#1A2027",
//     A100: "#f5f5f5",
//     A200: "#eeeeee",
//     A400: "#bdbdbd",
//     A700: "#616161",
//   },
//   error: {
//     50: "#FFF0F1",
//     100: "#FFDBDE",
//     200: "#FFBDC2",
//     300: "#FF99A2",
//     400: "#FF7A86",
//     500: "#FF505F",
//     600: "#EB0014",
//     700: "#C70011",
//     800: "#94000D",
//     900: "#570007",
//     main: "#EB0014",
//     light: "#FF99A2",
//     dark: "#C70011",
//     contrastText: "#fff",
//   },
//   success: {
//     50: "#E9FBF0",
//     100: "#C6F6D9",
//     200: "#9AEFBC",
//     300: "#6AE79C",
//     400: "#3EE07F",
//     500: "#21CC66",
//     600: "#1DB45A",
//     700: "#1AA251",
//     800: "#178D46",
//     900: "#0F5C2E",
//     main: "#1AA251",
//     light: "#6AE79C",
//     dark: "#1AA251",
//     contrastText: "#fff",
//   },
//   warning: {
//     50: "#FFF9EB",
//     100: "#FFF3C1",
//     200: "#FFECA1",
//     300: "#FFDC48",
//     400: "#F4C000",
//     500: "#DEA500",
//     600: "#D18E00",
//     700: "#AB6800",
//     800: "#8C5800",
//     900: "#5A3600",
//     main: "#DEA500",
//     light: "#FFDC48",
//     dark: "#AB6800",
//     contrastText: "rgba(0, 0, 0, 0.87)",
//   },
//   secondary: {
//     main: "#9c27b0",
//     light: "#ba68c8",
//     dark: "#7b1fa2",
//     contrastText: "#fff",
//   },
//   info: {
//     main: "#0288d1",
//     light: "#03a9f4",
//     dark: "#01579b",
//     contrastText: "#fff",
//   },
//   contrastThreshold: 3,
//   tonalOffset: 0.2,
//   background: {
//     paper: "#fff",
//     default: "#fff",
//   },
//   action: {
//     active: "rgba(0, 0, 0, 0.54)",
//     hover: "rgba(0, 0, 0, 0.04)",
//     hoverOpacity: 0.04,
//     selected: "rgba(0, 0, 0, 0.08)",
//     selectedOpacity: 0.08,
//     disabled: "rgba(0, 0, 0, 0.26)",
//     disabledBackground: "rgba(0, 0, 0, 0.12)",
//     disabledOpacity: 0.38,
//     focus: "rgba(0, 0, 0, 0.12)",
//     focusOpacity: 0.12,
//     activatedOpacity: 0.12,
//   },
// },
// shape: {
//   borderRadius: 10,
// },
// unstable_strictMode: true,
// typography: {
//   fontFamily:
//     '"IBM Plex Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//   fontFamilyCode: "Consolas,Menlo,Monaco,Andale Mono,Ubuntu Mono,monospace",
//   fontFamilyTagline:
//     '"PlusJakartaSans-ExtraBold",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//   fontFamilySystem:
//     '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//   fontWeightSemiBold: 600,
//   fontWeightExtraBold: 800,
//   h1: {
//     fontFamily:
//       '"PlusJakartaSans-ExtraBold",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//     fontSize: "clamp(2.625rem, 1.2857rem + 3.5714vw, 4rem)",
//     fontWeight: 800,
//     lineHeight: 1.1142857142857143,
//     color: "#0A1929",
//     scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)",
//   },
//   h2: {
//     fontFamily:
//       '"PlusJakartaSans-ExtraBold",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//     fontSize: "clamp(1.5rem, 0.9643rem + 1.4286vw, 2.25rem)",
//     fontWeight: 800,
//     lineHeight: 1.2222222222222223,
//     color: "#132F4C",
//     scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)",
//   },
//   h3: {
//     fontFamily:
//       '"PlusJakartaSans-Bold",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//     fontSize: "2.25rem",
//     lineHeight: 1.2222222222222223,
//     letterSpacing: 0.2,
//     fontWeight: 400,
//     scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)",
//   },
//   h4: {
//     fontFamily:
//       '"PlusJakartaSans-Bold",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//     fontSize: "1.75rem",
//     lineHeight: 1.5,
//     letterSpacing: 0.2,
//     fontWeight: 400,
//     scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)",
//   },
//   h5: {
//     fontFamily:
//       '"PlusJakartaSans-Bold",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//     fontSize: "1.5rem",
//     lineHeight: 1.5,
//     letterSpacing: 0.1,
//     color: "#007FFF",
//     fontWeight: 400,
//     scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)",
//   },
//   h6: {
//     fontSize: "1.25rem",
//     lineHeight: 1.5,
//     fontFamily:
//       '"IBM Plex Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//     fontWeight: 500,
//     scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)",
//   },
//   button: {
//     textTransform: "initial",
//     fontWeight: 700,
//     letterSpacing: 0,
//     fontFamily:
//       '"IBM Plex Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//     fontSize: "0.875rem",
//     lineHeight: 1.75,
//     scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)",
//   },
//   subtitle1: {
//     fontSize: "1.125rem",
//     lineHeight: 1.3333333333333333,
//     letterSpacing: 0,
//     fontWeight: 500,
//     fontFamily:
//       '"IBM Plex Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//     scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)",
//   },
//   body1: {
//     fontSize: "1rem",
//     lineHeight: 1.5,
//     letterSpacing: 0,
//     fontFamily:
//       '"IBM Plex Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//     fontWeight: 400,
//     scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)",
//   },
//   body2: {
//     fontSize: "0.875rem",
//     lineHeight: 1.5,
//     letterSpacing: 0,
//     fontFamily:
//       '"IBM Plex Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//     fontWeight: 400,
//     scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)",
//   },
//   caption: {
//     display: "inline-block",
//     fontSize: "0.75rem",
//     lineHeight: 1.5,
//     letterSpacing: 0,
//     fontWeight: 700,
//     fontFamily:
//       '"IBM Plex Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//     scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)",
//   },
//   allVariants: {
//     scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)",
//   },
//   htmlFontSize: 16,
//   fontSize: 14,
//   fontWeightLight: 300,
//   fontWeightRegular: 400,
//   fontWeightMedium: 500,
//   fontWeightBold: 700,
//   subtitle2: {
//     fontFamily:
//       '"IBM Plex Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//     fontWeight: 500,
//     fontSize: "0.875rem",
//     lineHeight: 1.57,
//     scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)",
//   },
//   overline: {
//     fontFamily:
//       '"IBM Plex Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
//     fontWeight: 400,
//     fontSize: "0.75rem",
//     lineHeight: 2.66,
//     textTransform: "uppercase",
//     scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)",
//   },
// },
// nprogress: {
//   color: "#007FFF",
// },
// props: {
//   MuiBadge: {
//     overlap: "rectangular",
//   },
// },
// mixins: {
//   toolbar: {
//     minHeight: 56,
//     "@media (min-width:0px)": {
//       "@media (orientation: landscape)": {
//         minHeight: 48,
//       },
//     },
//     "@media (min-width:600px)": {
//       minHeight: 64,
//     },
//   },
// },
// shadows: [
//   "none",
//   "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
//   "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
//   "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)",
//   "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
//   "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
//   "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
//   "0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)",
//   "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
//   "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
//   "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
//   "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
//   "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
//   "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
//   "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
//   "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
//   "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
//   "0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
//   "0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
//   "0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
//   "0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
//   "0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
//   "0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
//   "0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
//   "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)",
// ],
// transitions: {
//   easing: {
//     easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
//     easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
//     easeIn: "cubic-bezier(0.4, 0, 1, 1)",
//     sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
//   },
//   duration: {
//     shortest: 150,
//     shorter: 200,
//     short: 250,
//     standard: 300,
//     complex: 375,
//     enteringScreen: 225,
//     leavingScreen: 195,
//   },
// },
// zIndex: {
//   mobileStepper: 1000,
//   fab: 1050,
//   speedDial: 1050,
//   appBar: 1100,
//   drawer: 1200,
//   modal: 1300,
//   snackbar: 1400,
//   tooltip: 1500,
// },
